import { BaseEntity } from '../../../models';
import { UnidadeNegocio } from '../unidade-negocio';
import { LinhaProducao } from '../../linha-producao';

export class UnidadeNegocioLinhaProducao implements BaseEntity {
    readonly id: number;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idLinhaProducao: number;
    linhaProducao: LinhaProducao;
    cotacaoItemFormulario: number;
}
